import React, { useState, useEffect } from 'react';
import * as d3 from "d3";
import Selector from "./dataReader/selector"
import sample from "../../data/sample.tsv"

function Header (props){
    const data = props.data,
        setData = props.setData,
        format = props.format,
        extra = props.extra,
        setExtra = props.setExtra,
        getExtra = props.getExtra;

    const [dataRaw,setDataRaw] = useState([])
    const [filename, setFilename] = useState(undefined)

    d3.select('#logo_mmp').select('img')
        .on('mouseenter', function(){
            d3.select(this)
                .transition().duration(200)
                    .style('opacity', 0)
                    .transition().duration(500)
                        .style('opacity', 1)
                        .attr('width', '200px')
                        .attr('src', '../../img/mmp_logo2.svg')
        })
        .on('mouseleave', function(){
            d3.select(this)
                .transition().duration(200)
                    .style('opacity', 0)
                        .transition().duration(500)
                        .style('opacity', 1)
                        .attr('width', '30px')
                        .attr('src', '../../img/mmp_simple-logo.svg')
        });

    function drawVisualization (data, filename) {
        setData([]);
        setDataRaw(data);
        setFilename(filename)

        d3.select('#b_uploadLabel')
            .html('Load new dataset')
            .attr('class', 'buttonOutline');

        d3.select('#b_sample')
            .html('Use sample data')
            .attr('class', 'buttonOutline');

        d3.select('#logo_mmp')
            .style('padding', '5px 0 0 5px')
            .select('img')
                .attr('src', '../../img/mmp_simple-logo.svg')
                .transition().duration(1000).ease(d3.easePoly.exponent(3))
                .attr('height', '26px')
                .attr('width', '30px')
                .style('padding', '0');
        
        d3.select('#logo_finngen')
            .style('opacity', 0)
            .style('display', 'flex')
            .transition().delay(1000).duration(1000)
                .style('opacity', 1)

        d3.select('#header_filename')
            .style('opacity', 0)
            .style('display', 'flex')
            .transition().delay(2000).duration(1000)
                .style('opacity', 1)
        
        d3.select('#header')
            .style('margin', '0')
            .style('flex-direction', 'row')
            .style('justify-content', 'space-between')
            .style('background-color', '#0028d1')
            .style('position', 'fixed')
            .style('top', '0')
            .style('box-shadow', '0 0 10px black')
            .style('width', '100%');
    }

    useEffect (()=>{
    })

    return(
        <>
            <div id="header">
                <div id="header_logos">
                    <div id="logo_finngen" style={{display: 'none'}}>
                        <a href="https://www.finngen.fi/en" target="_blank">
                            <img src='../../img/finngen_logo.svg' height="26px" alt="FinnGen logo" />
                        </a>
                    </div>
                    <div id="logo_mmp">
                        <img src='../../img/mmp_logo.svg' height="100px" alt="MMP logo" />
                    </div>
                    <div id="header_filename" style={{display: 'none'}}>
                        <h2>{filename}</h2>
                    </div>
                </div>
                <div id="header_buttons">
                    <div id='header_mode' style={{display: data.length === 0 && 'none'}}>
                        <p style={{marginRight: 5}}>Mode</p>
                        <button id='b_modeChart' className='buttonOutline toggleLeft'>Chart search</button>
                        <button id='b_modeText' className='buttonOutline toggleRight'>Text search</button>
                    </div>
                    <div id='header_upload'>
                        <input 
                            id='b_uploadInput'
                            className='hiddenInput'
                            type='file' 
                            onChange={()=>{
                                d3.select('#b_uploadLabel')
                                    .html('Uploading dataset...')
                                    .classed('buttonPrimary', true);
                                props.handleDataChange([],[],[],[],[],[],[],[],[],[],[],[],[],[])
                                
                                const reader = new FileReader();
                                const dataFile = document.getElementById("b_uploadInput").files[0];
                    
                                reader.readAsText(dataFile,"UTF-8")
                                reader.onload = () => drawVisualization(d3.tsvParse(reader.result), dataFile.name)
                            }}
                        />
                        <label id='b_uploadLabel' className='buttonOutline' htmlFor='b_uploadInput'>Upload your dataset</label>
                        <button 
                            id='b_sample' 
                            className='buttonOutline' 
                            onClick={function(){
                                d3.select(this)
                                    .html('Uploading dataset...')
                                    .classed('buttonPrimary', true)
                                d3.tsv(sample).then(data => drawVisualization(data, '...'))
                            }}
                            >Use sample data</button>
                    </div>
                </div>
            </div>
            {(dataRaw.length > 0 && data.length === 0) && (
                <Selector 
                    handleDataChange={props.handleDataChange}
                    extra={extra}
                    setExtra={setExtra}
                    getExtra={getExtra}
                    data={dataRaw}
                    format={format}
                    filename={filename}
                    setFilename={setFilename}
                />
            )}
        </>
    )
    
}
export default Header;